import { Link } from "react-router-dom";
import { Anchor } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="main-footer" className="border-t border-border bg-abyss">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="h-9 w-9 bg-safety flex items-center justify-center font-heading font-black text-white text-lg">
                            K
                        </span>
                        <span className="font-heading font-extrabold tracking-tight text-lg">
                            KEVA SERVICE
                        </span>
                    </div>
                    <p className="text-steel max-w-md leading-relaxed">
                        Offshore-only HVAC, air filtration and hazardous gas pressurization
                        engineering. Keeping crews safe and platforms compliant in the harshest
                        marine environments on earth.
                    </p>
                </div>

                <div>
                    <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-steel mb-4">
                        Operations
                    </h4>
                    <ul className="space-y-3 text-sm text-foreground/90">
                        <li>North Sea · Gulf · West Africa</li>
                        <li>24/7 Offshore Dispatch</li>
                        <li>ATEX / IECEx Certified</li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-steel mb-4">
                        Contact
                    </h4>
                    <ul className="space-y-3 text-sm text-foreground/90">
                        <li>
                            <a href="mailto:ops@kevaservice.com" className="hover:text-safety transition-colors">
                                ops@kevaservice.com
                            </a>
                        </li>
                        <li>
                            <a href="tel:+4402080000000" className="hover:text-safety transition-colors">
                                +44 (0) 20 8000 0000
                            </a>
                        </li>
                        <li>
                            <Link
                                to="/admin/login"
                                data-testid="footer-admin-link"
                                className="text-steel hover:text-safety transition-colors"
                            >
                                Admin Portal
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-border">
                <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-steel">
                        © {new Date().getFullYear()} Keva Service Ltd.
                    </p>
                    <p className="flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-steel">
                        <Anchor className="h-3.5 w-3.5 text-safety" /> Offshore Services Only
                    </p>
                </div>
            </div>
        </footer>
    );
}
